var React = require('react');
var PropTypes = React.PropTypes;
var moment = require('moment');
// var Auth = require('../../resources/auth');
var request = require('superagent');
var env = require("../../utils/env");
var Helpers = require("../../utils/helpers");
var CollectionRes = require("../../resources/collection");
var apiDomain = env.domain.api;
// import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import { Link } from 'react-router';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import createConfirm from '../Modal/createConfirm';
import notification from '../Modal/notification';
import async from 'async';
import $ from 'jquery';
var ReviewTaskRes = require('../../resources/review_task');

var CollectionsTable = React.createClass({
  actionByType: function(type, data) {
    var _this = this;
    var result;
    type = type.toLowerCase();
    switch(type) {
      case 'edit':
        result = <Link to={"collection/" + data._id}><button className="btn primary"><i className="fa fa-edit"></i>Edit</button></Link>;
        break;
      case 'admin-edit':
        result = <Link to={"revise/" + data._id}><button className="btn primary"><i className="fa fa-edit"></i>Edit</button></Link>;
        break;
      case 'delete':
        result = <button className="btn negative" onClick={_this.modifyCollection.bind(_this, 'delete',data)}><i className="fa fa-trash"></i>Delete</button>;
        break;
      case 'view':
        result = <Link to={"view/" + data._id}><button className="btn secondary"><i className="fa fa-eye"></i>View</button></Link>;
        break;
      case 'revise':
        result = <Link to={"revise/" + data._id}><button className="btn secondary" ><i className="fa fa-undo"></i>Revise</button></Link>;
        break;
      case 'assign':
        result = <button className="btn primary" onClick={_this.modifyCollection.bind(_this, 'assign',data)}><i className="fa fa-user"></i>Assign</button>;
        break;
      case 'reassign':
        result = <button className="btn primary" onClick={_this.modifyCollection.bind(_this, 'reassign',data)}><i className="fa fa-user"></i>Re-assign</button>;
        break;
      case 'review':
        result = <Link to={"review/" + data._id}><button className="btn secondary"><i className="fa fa-comments-o"></i>Review</button></Link>;
        break;
      case 'admin-review':
        result = <Link to={"view/" + data._id}><button className="btn secondary"><i className="fa fa-comments-o"></i>Review</button></Link>;
        break;
      case 'publish':
        if (data.status === 'complete')
          result = <button className="btn" onClick={_this.modifyCollection.bind(_this, 'publish',data)}><i className="fa fa-upload"></i>Publish</button>;
        else if (data.status === 'published')
          result = <button className="btn unpublish" onClick={_this.modifyCollection.bind(_this, 'unpublish',data)}><i className="fa fa-download"></i>Un-publish</button>;
          // result = <span className="text"><i className="fa fa-check"></i>Published</span>
        break;
      case 'recover':
        result = <button className="btn primary" onClick={_this.modifyCollection.bind(_this, 'recover',data)}><i className="fa fa-undo"></i>Recover</button>;
        break;
      default:
        result = null;
        break;
    }
    return result;
  },

  renderHeaderRows: function(types) {
    var result = [],
        _this = this;
    for (var i = 0; i < types.length; i++) {
      var type = types[i];
      switch(type) {
        case 'title':
          result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'title')}>
            Title
            {this.getSortIcon('title')}
          </th>);
          break;
        case 'subject':
          result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'metadata.subjectName')}>
            <span>
              Subject
              {this.getSortIcon('metadata.subjectName')}
            </span>
          </th>);
          break;
        case 'concept':
          result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'metadata.conceptName')}>
            <span>
              Concept
              {this.getSortIcon('metadata.conceptName')}
            </span>
          </th>);
          break;
        case 'mcqStat':
          result.push(<th key={type}>MCQ</th>);
          break;
        case 'ssStat':
          result.push(<th key={type}>SS</th>);
          break;
        case 'lsStat':
          result.push(<th key={type}>LS</th>);
          break;
        case 'reviewer':
          result.push(<th key={type}>Reviewers</th>);
          break;
        case 'finishReview':
          result.push(<th key={type}>Finished Review</th>);
          break;
        case 'dateCreated':
          result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'dateCreated')}>
            Date Created
            {this.getSortIcon('dateCreated')}
          </th>);
          break;
        case 'dateModified':
          result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'dateModified')}>
            Date Updated
            {this.getSortIcon('dateModified')}
          </th>);
          break;
        case 'dateSubmitted':
          result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'date_submitted')}>
            Date Submitted
            {this.getSortIcon('date_submitted')}
          </th>);
          break;
        case 'creator':
          result.push(<th key={type}>Creator</th>);
          break;
        case 'round':
          result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'current_review_round')}>
            Round
            {this.getSortIcon('current_review_round')}
          </th>)
          break;
        case 'actions':
          result.push(<th key={type}>Actions</th>);
          break;
        default: break;
      }
    }
    return (
      <tr>
        {
          result.map((value, index) => {
            return value
          })
        }
      </tr>
    )
  },

  renderDataRows: function(types, data, conceptsMap) {
    var result = [],
        _this = this;
    for (var i = 0; i < types.length; i++) {
      var type = types[i];
      switch(type) {
        case 'title':
          result.push(<td key={type}>
            {data.title || 'No title'}
          </td>);
          break;
        case 'subject':
          result.push(<td key={type}>
            {data.concepts[0] && _this.state.conceptsMap ? Helpers.getSubject(_this.state.conceptsMap, data.concepts[0]).title : "No Subject"}
          </td>);
          break;
        case 'concept':
          result.push(<td key={type}>
            {data.concepts[0] && _this.state.conceptsMap && _this.state.conceptsMap[data.concepts[0]] ? _this.state.conceptsMap[data.concepts[0]].title : "No Concept"}
          </td>);
          break;
        case 'mcqStat':
          result.push(<td key={type}>
            {data.questionStatMapping && data.questionStatMapping[11] ? data.questionStatMapping[11].count : '0'}
          </td>);
          break;
        case 'ssStat':
          result.push(<td key={type}>
            {data.questionStatMapping && data.questionStatMapping[21] ? data.questionStatMapping[21].count : '0'}
          </td>);
          break;
        case 'lsStat':
          result.push(<td key={type}>
            {data.questionStatMapping && data.questionStatMapping[22] ? data.questionStatMapping[22].count : '0'}
          </td>)
          break;
        case 'reviewer':
          var reviewersSpan = data.reviewTasks.filter(function(task) {
            var currentRound = data.current_review_round;
            if (task.status === 'cancelled') return false;
            if (currentRound !== task.reviewRound) return false;
            return true;
          }).map(function(task, taskIndex) {
            var text = taskIndex === 0 ? task.reviewerName : (', ' + task.reviewerName);
            return (
              <span className={(task.status === 'done' || task.status === 'reviewing') ? 'txt-success' : ''} key={taskIndex}>{text}</span>
            )
          });
          result.push(<td key={type}>{reviewersSpan}</td>);
          break;
        case 'finishReview':
          result.push(<td key={type}>
            {(data.reviewStatMapping ? data.reviewStatMapping['currentDone'] : "-") + "/" + (data.reviewStatMapping ? data.reviewStatMapping['currentTotal'] : "-")}
          </td>)
          break;
        case 'dateCreated':
          result.push(<td key={type}>
            {moment(data.dateCreated).format("MM/DD/YYYY")}
          </td>);
          break;
        case 'dateModified':
          result.push(<td key={type}>
            {moment(data.dateModified).format("MM/DD/YYYY")}
          </td>);
          break;
        case 'dateSubmitted':
          result.push(<td key={type}>
            {moment(data.date_submitted).format("MM/DD/YYYY")}
          </td>);
          break;
        case 'creator':
          result.push(<td key={type}>
            {data.creatorName}
          </td>);
          break;
        case 'round':
          result.push(<td key={type}>
            {data.current_review_round}
          </td>);
          break;
        case 'actions':
          var actionsEl = (
            <td className="action" key={type}>
              {
                this.state.mode.actions.map(function(action, index) {
                  return (
                    <div key={index} className="dp-inline-block">
                      {_this.actionByType(action, data)}
                    </div>
                  )
                })
              }
            </td>
          )
          result.push(actionsEl)
          break;
        default: break;
      }
    }
    return (
      <tr key={data._id}>
        {
          result.map((data, index) => {
            return data;
          })
        }
      </tr>
    )
  },

  getSortIcon: function(currentSort) {
    var ascSortIcon = <span className="fa fa-caret-up padding-left-5"></span>,
    descSortIcon = <span className="fa fa-caret-down padding-left-5"></span>,
    sortIcon = <span className="fa fa-sort padding-left-5"></span>,
    sort = this.state.sort;
    if (sort.indexOf(currentSort) >= 0) {
      if (sort.charAt(0) === '-') return descSortIcon;
      else return ascSortIcon;
    } else {
      return sortIcon;
    }
  },

  modifyCollection: function(type, collection) {
    type = type.toLowerCase();
    switch(type) {
      case 'delete':
        this.props.onDelete(collection); break;
      case 'assign':
        this.openAssignDialog(collection); break;
      case 'reassign':
        this.openAssignDialog(collection, 'reassign'); break;
      case 'publish':
        this.publishCollection(collection); break;
      case 'unpublish':
        this.unpublishCollection(collection); break;
      case 'recover':
        this.recoverCollection(collection); break;
      default:
        break;
    }
  },

  publishCollection: function(collection) {
    // var r = confirm("Are you sure you want to publish this collection?");
    // if (!r) return;
    this.setState({openConfirm: true});
    this.confirmable = createConfirm({
      title: 'CONFIRM',
      content: 'Are you sure you want to publish this collection?'
    }, () => {
      this.setState({openConfirm: false});
      $("body, html").addClass("heavy-load");
      var _body = {
        status: 'public'
      }
      CollectionRes.updateAllKquestionInCollection({
        collectionId: collection._id,
        body: _body
      }, (err, res) => {
        if (!err && res) {
          collection.status = 'published';
          CollectionRes.updateCollectionOnly(collection, (err2, res2) => {
            if (!err2 && res2) {
              $("body, html").removeClass("heavy-load");
              notification.open({
                message: 'Success',
                description: "You have successfully published the collection"
              })
              // alert("You have successfully published the collection");
              this.forceUpdate();
            } else {
              $("body, html").removeClass("heavy-load");
              notification.open({
                message: 'Success',
                description: "Cannot publish the collection. Please try again"
              })
              // alert("Cannot publish the collection. Please try again");
            }
          })
        }
      })
    }, () => {
      this.setState({openConfirm: false});
    });
  },

  unpublishCollection: function(collection) {
    // var r = confirm("Are you sure you want to publish this collection?");
    // if (!r) return;
    this.setState({openConfirm: true});
    this.confirmable = createConfirm({
      title: 'CONFIRM',
      content: 'Are you sure you want to un-publish this collection?'
    }, () => {
      this.setState({openConfirm: false});
      $("body, html").addClass("heavy-load");
      var _body = {
        status: 'self'
      }
      CollectionRes.updateAllKquestionInCollection({
        collectionId: collection._id,
        body: _body
      }, (err, res) => {
        if (!err && res) {

          collection.status = 'complete';
          CollectionRes.updateCollectionOnly(collection, (err2, res2) => {
            if (!err2 && res2) {
              $("body, html").removeClass("heavy-load");
              notification.open({
                message: 'Success',
                description: "You have successfully un-published the collection"
              })
              // alert("You have successfully published the collection");
              this.forceUpdate();
            } else {
              $("body, html").removeClass("heavy-load");
              notification.open({
                message: 'Success',
                description: "Cannot un-publish the collection. Please try again"
              })
              // alert("Cannot publish the collection. Please try again");
            }
          })

        }
      })
    }, () => {
      this.setState({openConfirm: false});
    });
  },

  recoverCollection: function(collection) {
    // var r = confirm("Are you sure you want to recover this collection for reviewing?");
    // if (!r) return;
    this.setState({openConfirm: true});
    this.confirmable = createConfirm({
      title: 'CONFIRM',
      content: 'Are you sure you want to recover this collection for reviewing?'
    }, () => {
      this.setState({openConfirm: false});
      collection.status = 'reviewing';
      CollectionRes.updateCollectionOnly(collection, (err, res) => {
        if (!err && res) {
          notification.open({
            message: 'Success',
            description: 'You have successfully recovered the collection'
          })
          // alert("You have successfully recovered the collection");
          var collectionData = this.state.data;
          collectionData.splice(collectionData.indexOf(collection), 1);
          this.setState({data: collectionData});
        } else {
          notification.open({
            message: 'Error',
            description: "Cannot recover the collection. Please try again"
          })
          // alert("Cannot recover the collection. Please try again");
        }
      })
    }, () => {
      this.setState({openConfirm: false});
    });
  },

  retrieveReviewersList: function(callback) {
    callback = callback || function(){};
    request.get(apiDomain + "/v1/users")
    .query({
      conditions: JSON.stringify({
        status: {
          "$in": ["reviewer"]
        }
      })
    })
    .withCredentials()
    .then(function(response) {
      return callback(null, response.body)
    }, function(err){
      return callback(err)
    })
  },

  openAssignDialog: function(collection, assignType) {
    assignType = assignType || 'assign';
    var _this = this;
    // Map reviewer by only current round
    if (!collection.reviewersMap) collection.reviewersMap = {};
    for (var i = 0; i < collection.reviewTasks.length; i++) {
      if (collection.current_review_round !== collection.reviewTasks[i].reviewRound) continue;
      collection.reviewersMap[collection.reviewTasks[i].reviewer] = collection.reviewTasks[i];
    }
    if (!this.state.listReviewers || this.state.listReviewers.length <= 0) {
      _this.setState({isLoadingReviewers: true});
      _this.retrieveReviewersList(function(err, res) {
        if (res) res.sort(function(a, b) {
          const aName = a.firstName + ' ' + a.lastName,
                bName = b.firstName + ' ' + b.lastName;
          if (aName.toLowerCase() < bName.toLowerCase()) return -1;
          return 1;
        })
        _this.setState({
          isLoadingReviewers: false,
          listReviewers: (!err && res) ? res : []
        })
      })
    }
    this.setState({
      isOpenAssignDialog: true,
      assignType: assignType,
      assignedCollection: collection,
      isAssigning: false
    })
  },

  closeAssignTaskModal: function() {
    this.setState({
      isOpenAssignDialog: false,
      assignedCollection: null,
      assignedReviewers: [],
      removedReviewers: [],
      selectReviewerError: false
    })
  },

  assignTo: function(reviewer, e, isAssignedTo) {
    var assignedReviewers = this.state.assignedReviewers;
    var removedReviewers = this.state.removedReviewers;
    var oldReviewerMap = this.state.assignedCollection.reviewersMap;
    var collectionRound = this.state.assignedCollection.current_review_round;
    var reviewerRound = oldReviewerMap[reviewer._id] ? oldReviewerMap[reviewer._id].reviewRound : -1;
    var isSameRound = collectionRound === reviewerRound;
    if (isAssignedTo) {
      // Re-assign old reviewer: Remove reviewer from removedReviewers list
      if (isSameRound) {
        if (removedReviewers.indexOf(reviewer) >= 0) removedReviewers.splice(removedReviewers.indexOf(reviewer),1);
      }
      // Assign new reviewer: push reviewer to assignedReviewers list
      else {
        if (assignedReviewers.indexOf(reviewer) < 0) assignedReviewers.push(reviewer)
      }
    } else {
      // Remove old reviewer: Add reviewer to removedReviewers list
      if (isSameRound) {
        if (removedReviewers.indexOf(reviewer) < 0) removedReviewers.push(reviewer)
      }
      // Remove new reviewer: remove reviewer from assignedReviewers list
      else {
        if (assignedReviewers.indexOf(reviewer) >= 0) assignedReviewers.splice(assignedReviewers.indexOf(reviewer), 1);
      }
    }
    // return console.log(assignedReviewers, removedReviewers);
    this.setState({
      assignedReviewers: assignedReviewers,
      removedReviewers: removedReviewers
    })
  },

  doAssign: function() {
    this.setState({selectReviewerError: false});
    var reviewers = this.state.assignedReviewers,
        removedReviewers = this.state.removedReviewers,
        content = this.state.assignedCollection._id,
        count = this.state.assignedReviewers.length,
        _this = this;

    if (reviewers.length === 0 && removedReviewers.length === 0) {
      // Show error message when no reviewers selected, no removedReviewer selected and this collection task is empty
      if (!this.state.assignedCollection.reviewTasks || this.state.assignedCollection.reviewTasks.length === 0) {
        return this.setState({
          selectReviewerError: true
        });
      }
      // Else close dialog only
      else {
        return this.setState({
          isOpenAssignDialog: false
        })
      }
    }
    var callbackArr = [];
    for (var i in reviewers) {
      this.createAssignTask(callbackArr, reviewers[i], content);
    }
    for (var j = 0; j < removedReviewers.length; j++) {
      var reviewTaskToRemove = this.state.assignedCollection.reviewersMap[removedReviewers[j]._id];
      this.createCancelTask(callbackArr, reviewTaskToRemove);
    }

    this.setState({
      isAssigning: true,
    }, () => {
      async.parallel(callbackArr, (err, resArr) => {
        this.props.onUpdateSingleCollection(this.state.assignedCollection, function(err2, newCollection) {
          for (var i = 0; i < _this.state.data.length; i++) {
            var data = _this.state.data[i];
            if (data._id === content) {
              Object.assign(data, newCollection);
              // Override reviewers list
              data.reviewersMap = {};
              for (var j = 0; j < data.reviewTasks.length; j++) {
                data.reviewersMap[data.reviewTasks[j].reviewer] = data.reviewTasks[j];
              }
            }
          }
          var cancelTaskError = false,
              createTaskError = false;
          var createTaskErrorUsers = [];
          for (var i = 0; i < resArr.length; i++) {
            if (resArr[i]['cancel-err']) cancelTaskError = true;
            if (resArr[i]['create-err']) {
              createTaskError = true;
              createTaskErrorUsers.push(resArr[i]['create-err'].firstName + ' ' + resArr[i]['create-err'].lastName);
            }
          }
          if (cancelTaskError) {
            var btn = <button className="btn" onClick={Helpers.windowReload}></button>
            notification.open({
              message: 'Error',
              description: 'Some errors happened. Please reload page and try again',
              btn,
              duration: 0
            })
          } else if (createTaskError) {
            var description = 'Cannot assign task to reviewer: ' + createTaskErrorUsers.join(', ') + '. ' + (createTaskErrorUsers.length > 1 ? 'Their tasks have been cancelled before' : 'His task has been cancelled before');
            notification.open({
              message: 'Error',
              description: description,
              duration: 10
            })
          } else {
            notification.open({
              message: 'Done',
              description: 'Collection has been assigned to reviewer(s)'
            })
          }
          _this.setState({
            data: _this.state.data,
            isOpenAssignDialog: false,
            assignedReviewers: [],
            removedReviewers: []
          })
        })
      })
    });
  },

  createCancelTask: function(callbackArr, reviewTask) {
    callbackArr.push(function(callback) {
      var options = {
        taskId: reviewTask._id,
        body: {
          status: 'cancelled'
        }
      }
      var _this = this;
      ReviewTaskRes.updateReviewTask(options, function(err, res) {
        return callback(null, (!err && res) ? res : {'cancel-err': reviewTask});
      })
    })
  },

  createAssignTask: function(callbackArr, reviewer, collectionId){
    callbackArr.push(function(callback) {
      request.post(apiDomain + "/v1/review_task")
      .send({
        type: "COLLECTION_REVIEW",
        reviewer: reviewer._id,
        // reviewRound: 1,
        content: collectionId,
        reviewerName: reviewer.firstName + ' ' + reviewer.lastName
      })
      .withCredentials()
      .then(function(response) {
        return callback(null, response.body)
      }, function(err) {
        return callback(null, {'create-err': reviewer});
      })
    })
  },

  changeSort: function(chosenSort) {
    var newSort;
    if (this.state.sort.indexOf(chosenSort) >= 0) {
      var sort = this.state.sort;
      if (sort.charAt(0) === '-') newSort = sort.substr(1, sort.length);
      else newSort = '-'  + sort;
    } else {
      newSort = '-' + chosenSort;
    }
    if (this.props.onSortChange && typeof this.props.onSortChange === 'function') {
      this.props.onSortChange(newSort);
    }
  },

  getInitialState: function() {
    return {
      data: this.props.data,
      conceptsMap: this.props.conceptsMap,
      isOpenAssignDialog: false,
      listReviewers: [],
      isLoadingReviewers: false,
      isAssigning: false,
      assignedCollection: null,
      assignedReviewers: [],
      removedReviewers: [],
      mode: this.props.mode,
      sort: this.props.sort
    };
  },

  componentWillReceiveProps: function(nextProps) {
    this.setState({
      data: nextProps.data || this.state.data,
      conceptsMap: nextProps.conceptsMap || this.state.conceptsMap,
      mode: nextProps.mode || this.state.mode,
      sort: nextProps.sort || this.state.sort
    })
  },

  componentWillMount: function() {

  },

  render: function() {
    var _this = this;
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.closeAssignTaskModal}
      />,
      <RaisedButton
        label={this.state.assignType === 'assign' ? "Assign" : "Re-assign"}
        primary={true}
        onClick={this.doAssign}/>
    ];
    return (
      <div className="collection-table">
        {this.state.openConfirm && this.confirmable}
        {
          this.state.mode.notes &&
          <p className="txt-primary text-left" style={{fontSize: "13px"}}>
            {
              _this.state.mode.notes.map(function(data, index) {
                return (<span key={index}><i>* {data}</i><br/></span>)
              })
            }
          </p>
        }
        <table className="table table-bordered table-striped">
          <thead>
            {
              _this.renderHeaderRows(this.state.mode.cols)
            }
          </thead>
          <tbody>
          {
            _this.state.data.map(function(data, index) {
              if (_this.state.mode.value.indexOf(data.status) < 0) return null;
              return (
                _this.renderDataRows(_this.state.mode.cols, data, _this.state.conceptsMap)
              )
            })
          }
          </tbody>
        </table>
        <Dialog
          title={this.state.assignType === 'assign' ? "Assign to Reviewer" : "Re-assign to Reviewer"}
          actions={actions}
          modal={false}
          open={this.state.isOpenAssignDialog}
          autoScrollBodyContent={true}
        >
          {
            _this.state.isLoadingReviewers && <CircularProgress />
          }
          {
            !_this.state.isLoadingReviewers && _this.state.listReviewers && _this.state.assignedCollection && (
              <div className="padding-top-20">
                {
                  _this.state.selectReviewerError &&
                  <p className="txt-danger">Please select at least 1 reviewer</p>
                }
                {
                  _this.state.listReviewers.map(function(reviewer, index) {
                    const isAssigned = _this.state.assignedCollection && _this.state.assignedCollection.reviewersMap && !!_this.state.assignedCollection.reviewersMap[reviewer._id];
                    const collectionRound = _this.state.assignedCollection.current_review_round;
                    const reviewerRound = isAssigned ? _this.state.assignedCollection.reviewersMap[reviewer._id].reviewRound : -1;
                    const isSameRound = collectionRound === reviewerRound;
                    const isDone = isAssigned && _this.state.assignedCollection.reviewersMap[reviewer._id].status === 'done';
                    return (
                      <div key={index}>
                        <Checkbox
                          label={reviewer.firstName + ' ' + reviewer.lastName + (isDone ? ' (Finished)' : '')}
                          onCheck={_this.assignTo.bind(_this, reviewer)}
                          defaultChecked={isAssigned && isSameRound}
                          disabled={isDone}
                        />
                      </div>
                    )
                  })
                }
              </div>
            )
          }
          {
            _this.state.isAssigning && <CircularProgress />
          }
        </Dialog>
      </div>
    );
  },

  componentDidMount: function() {

  }

});

module.exports = CollectionsTable;



/** WEBPACK FOOTER **
 ** ./src/components/Collections/CollectionsTable.js
 **/